//////////////////////////////////////
/////// DDG customization note ///////
//////////////////////////////////////
//  As of the time this note is written, this unit type is not being fully 
// used, e.g. we don't display text messages such as "price per event". This
// event type is currently unknown to FormattedMessage utils which makes it
// fall back to default e.g. "price".
export const DDG_UNIT_TYPE_EVENT = "event";

export const PROVIDER_USER_TYPE = "provider"

// add-ons
export const DDG_ADD_ON_ID_TO_NAME_MAP = {
   'equipmentRental': 'Equipment Rental',
   'nitroxUpgrade': 'Nitrox Upgrade',
   'eLearning': 'E-Learning',
   'boatDive': 'Boat Dive',
}

export const DEFAULT_ADD_ON_QTY_OPTIONS = [1,2,3,4,5];

// Course-specific customizations
export const AGENCY_NAME_PADI = 'PADI';
export const AGENCY_NAME_SSI = 'SSI';
export const AGENCY_NAME_BSAC = 'BSAC';
export const AGENCY_NAME_ACUC = 'ACUC';
export const AGENCY_NAME_SDI = 'SDI';
export const AGENCY_NAME_NAUI = 'NAUI';
export const AGENCY_NAME_CMAS = 'CMAS';
export const AGENCY_NAME_AIDA = 'AIDA';
export const AGENCY_NAME_TDI = 'TDI';
export const AGENCY_NAME_RAID = 'RAID';
export const AGENCY_NAME_IANTD = 'IANTD';
export const AGENCY_NAME_PFI = 'PFI';
export const AGENCY_NAME_ERDI = 'ERDI';
export const AGENCY_NAME_GUE = 'GUE';
export const AGENCY_NAME_NSS_CDS = 'NSS_CDS';

export const ALL_AGENCY_NAMES = [
   AGENCY_NAME_PADI,
   AGENCY_NAME_SSI,
   AGENCY_NAME_BSAC,
   AGENCY_NAME_ACUC,
   AGENCY_NAME_SDI,
   AGENCY_NAME_NAUI,
   AGENCY_NAME_CMAS,
   AGENCY_NAME_AIDA,
   AGENCY_NAME_TDI,
   AGENCY_NAME_RAID,
   AGENCY_NAME_IANTD,
   AGENCY_NAME_PFI,
   AGENCY_NAME_ERDI ,
   AGENCY_NAME_GUE,
   AGENCY_NAME_NSS_CDS,
];

const COURSE_DESCRIPTION_RELATIVE_PATH = '/static/course_names';

export const AGENCY_NAME_TO_COURSE_DESCRIPTION_PATH = {
   [AGENCY_NAME_PADI]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/padi.json`,
   [AGENCY_NAME_SSI]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/ssi.json`,
   [AGENCY_NAME_SDI]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/sdi.json`,
   [AGENCY_NAME_TDI]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/tdi.json`,
   [AGENCY_NAME_PFI]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/pfi.json`,
   [AGENCY_NAME_ERDI]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/erdi.json`,
   [AGENCY_NAME_NAUI]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/naui.json`,
   [AGENCY_NAME_IANTD]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/iantd.json`,
   [AGENCY_NAME_BSAC]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/bsac.json`,
   [AGENCY_NAME_RAID]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/raid.json`,
   [AGENCY_NAME_AIDA]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/aida.json`,
   [AGENCY_NAME_CMAS]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/cmas.json`,
   [AGENCY_NAME_ACUC]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/acuc.json`,
   [AGENCY_NAME_GUE]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/gue.json`,
   [AGENCY_NAME_NSS_CDS]: `${COURSE_DESCRIPTION_RELATIVE_PATH}/nss_cds.json`,
};

// course type names

const COURSE_TYPE_NAME_BEGINNER = 'Beginner';
const COURSE_TYPE_NAME_ADVANCED_TRAINING = 'Advanced Training';
const COURSE_TYPE_NAME_NITROX = 'Nitrox';
const COURSE_TYPE_NAME_SPECIALTY_COURSES = 'Specialty Courses';
const COURSE_TYPE_NAME_ENVIRONMENT = 'Environment';
const COURSE_TYPE_NAME_FREE_DIVING = 'Free Diving';
const COURSE_TYPE_NAME_TECHNICAL_COURSES = 'Technical Courses';
const COURSE_TYPE_CAVE_DIVING = 'Cave Diving';
const COURSE_TYPE_NAME_REBREATHER = 'Rebreather';
const COURSE_TYPE_NAME_PROFESSIONAL = 'Professional';
const COURSE_TYPE_NAME_WRECK_DIVING = 'Wreck Diving';
const COURSE_TYPE_NAME_TRIMIX = 'Trimix';
const COURSE_TYPE_NAME_YOUTH = 'Youth';
const COURSE_TYPE_NAME_SNORKLING = 'Snorkling';
const COURSE_TYPE_NAME_REFRESHER_PROGRAM = 'Refresher Program';
const COURSE_TYPE_NAME_MINE_DIVING = 'Mine Diving';
const COURSE_TYPE_NAME_DIVERS_WITH_DISABILITY = 'Divers with disability';
const COURSE_TYPE_NAME_SIDEMOUNT = 'Sidemount';

// course type ids
const COURSE_TYPE_ID_BEGINNER = 'beginner';
const COURSE_TYPE_ID_ADVANCED_TRAINING = 'advancedTraining';
const COURSE_TYPE_ID_NITROX = 'nitrox';
const COURSE_TYPE_ID_SPECIALTY_COURSES = 'specialtyCourses';
const COURSE_TYPE_ID_ENVIRONMENT = 'environment';
const COURSE_TYPE_ID_FREE_DIVING = 'freeDiving';
const COURSE_TYPE_ID_TECHNICAL_COURSES = 'technicalCourses';
const COURSE_TYPE_ID_DIVING = 'caveDiving';
const COURSE_TYPE_ID_REBREATHER = 'rebreather';
const COURSE_TYPE_ID_PROFESSIONAL = 'professional';
const COURSE_TYPE_ID_WRECK_DIVING = 'wreckDiving';
const COURSE_TYPE_ID_TRIMIX = 'trimix';
const COURSE_TYPE_ID_YOUTH = 'youth';
const COURSE_TYPE_ID_SNORKLING = 'snorkling';
const COURSE_TYPE_ID_REFRESHER_PROGRAM = 'refresherProgram';
const COURSE_TYPE_ID_MINE_DIVING = 'mineDiving';
const COURSE_TYPE_ID_DIVERS_WITH_DISABILITY = 'diversWithDisability';
const COURSE_TYPE_ID_SIDEMOUNT = 'sidemount';

// course type name -> course type id map
export const COURSE_TYPE_ID_BY_COURSE_TYPE_NAME = {
   [COURSE_TYPE_NAME_BEGINNER]: COURSE_TYPE_ID_BEGINNER,
   [COURSE_TYPE_NAME_ADVANCED_TRAINING]: COURSE_TYPE_ID_ADVANCED_TRAINING,
   [COURSE_TYPE_NAME_NITROX]: COURSE_TYPE_ID_NITROX,
   [COURSE_TYPE_NAME_SPECIALTY_COURSES]: COURSE_TYPE_ID_SPECIALTY_COURSES,
   [COURSE_TYPE_NAME_ENVIRONMENT]: COURSE_TYPE_ID_ENVIRONMENT,
   [COURSE_TYPE_NAME_FREE_DIVING]: COURSE_TYPE_ID_FREE_DIVING,
   [COURSE_TYPE_NAME_TECHNICAL_COURSES]: COURSE_TYPE_ID_TECHNICAL_COURSES,
   [COURSE_TYPE_CAVE_DIVING]: COURSE_TYPE_ID_DIVING,
   [COURSE_TYPE_NAME_REBREATHER]: COURSE_TYPE_ID_REBREATHER,
   [COURSE_TYPE_NAME_PROFESSIONAL]: COURSE_TYPE_ID_PROFESSIONAL,
   [COURSE_TYPE_NAME_WRECK_DIVING]: COURSE_TYPE_ID_WRECK_DIVING,
   [COURSE_TYPE_NAME_TRIMIX]: COURSE_TYPE_ID_TRIMIX,
   [COURSE_TYPE_NAME_YOUTH]: COURSE_TYPE_ID_YOUTH,
   [COURSE_TYPE_NAME_SNORKLING]: COURSE_TYPE_ID_SNORKLING,
   [COURSE_TYPE_NAME_REFRESHER_PROGRAM]: COURSE_TYPE_ID_REFRESHER_PROGRAM,
   [COURSE_TYPE_NAME_MINE_DIVING]: COURSE_TYPE_ID_MINE_DIVING,
   [COURSE_TYPE_NAME_DIVERS_WITH_DISABILITY]: COURSE_TYPE_ID_DIVERS_WITH_DISABILITY,
   [COURSE_TYPE_NAME_SIDEMOUNT]: COURSE_TYPE_ID_SIDEMOUNT,
}

// Transaction process constants. Used for cancellation policies customizations
export const TRANSACTION_PROCESS_VERSION_0_ALIAS = 'default-booking/release-0';
export const TRANSACTION_PROCESS_VERSION_1_ALIAS = 'default-booking/release-1';
export const CANCELLATION_POLICY_FULL_REFUND_FORM_VALUE = 'full-refund';
export const CANCELLATION_POLICY_PARTIAL_REFUND_FORM_VALUE_7_14 = 'partial-refund-7-14';

// PayPal related stuff
export const PAYMENT_INTENT_AUTHORIZE = "AUTHORIZE";
export const PAYMENT_INTENT_CAPTURE = "CAPTURE";
export const CURRENCY_CODE_USD = "USD";
export const SHIPPING_PREFERENCE_NO_SHIPPING = "NO_SHIPPING";
export const PAYPAL_ORDER_STATUS_COMPLETED = "COMPLETED";
export const PAYPAL_ORDER_STATUS_VOIDED = "VOIDED";
export const DEFAULT_PURCHASE_UNIT_REFERENCE_ID = "diving-experience";
export const DEFAULT_PURCHASE_UNIT_DESCRIPTION = "Diving experience services";
export const DEFAULT_PURCHASE_UNIT_ITEM_NAME = "Diving experience services";
export const DISBURSMENT_MODE_DELAYED = "DELAYED";
export const DISBURSMENT_MODE_INSTANT = "INSTANT";
export const RESPONSE_CODE_COMPLETED = "COMPLETED";

export const PAYPAL_SCRIPT_PROVIDER_DEFAULT_OPTIONS = {
   "commit": true,
   "components": ["buttons"],
   "disable-funding": ["credit", "paylater"], // --> don't bother with paypal credit and pay later options for now
};

export const LINE_ITEM_PAYPAL_TRANSACTION_FEE = 'line-item/transaction-fee';
